module.exports = __webpack_public_path__ + "static/media/fondo_talleres.af4516eb.jpg";